module.exports = __webpack_public_path__ + "resources/icon-lottery.d6afaed63d7f6056.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-title/images/icon-lottery.png
// module id = 533
// module chunks = 0 1 2 3